const typograhpy = {
    text: {
        normal: {
            fontSize: {
                xxs: '16px',
                xs: '16px',
                sm: '16px',
                md: '16px',
                lg: '18px',
                xl: '24px'
            },
            lineHeight: {
                xxs: '24px',
                xs: '24px',
                sm: '24px',
                md: '24px',
                lg: '27px',
                xl: '36px'
            }
        },
        small: {
            fontSize: {
                xxs: '12px',
                xs: '12px',
                sm: '12px',
                md: '14px',
                lg: '16px',
                xl: '20px'
            },
            lineHeight: {
                xxs: '20px',
                xs: '20px',
                sm: '20px',
                md: '22px',
                lg: '24px',
                xl: '28px'
            }
        }
    },
    heading: {
        h1: {
            fontSize: {
                xxs: '37px',
                xs: '37px',
                sm: '60px',
                md: '79px',
                lg: '105px',
                xl: '147px'
            },
            lineHeight: {
                xxs: '100%'
            }
        },
        h2: {
            fontSize: {
                xxs: '29px',
                xs: '29px',
                sm: '47px',
                md: '62px',
                lg: '82px',
                xl: '115px'
            },
            lineHeight: {
                xxs: '100%'
            }
        },
        h3: {
            fontSize: {
                xxs: '23px',
                xs: '23px',
                sm: '37px',
                md: '49px',
                lg: '65px',
                xl: '91px'
            },
            lineHeight: {
                xxs: '100%'
            }
        },
        h4: {
            fontSize: {
                xxs: '23px',
                xs: '23px',
                sm: '29px',
                md: '38px',
                lg: '51px',
                xl: '71px'
            },
            lineHeight: {
                xxs: '100%'
            }
        },
        h5: {
            fontSize: {
                xxs: '23px',
                xs: '23px',
                sm: '23px',
                md: '30px',
                lg: '40px',
                xl: '56px'
            },
            lineHeight: {
                xxs: '100%'
            }
        },
        h6: {
            fontSize: {
                xxs: '23px',
                xs: '23px',
                sm: '23px',
                md: '24px',
                lg: '31px',
                xl: '44px'
            },
            lineHeight: {
                xxs: '100%'
            }
        }
    }
};

export default typograhpy;